export default __webpack_public_path__ + "static/media/pattern-left-side.ac6b9f32.png";